import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import LicenseInfo from './LicenseInfo';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function LicenseDialog({ open, onClose }: Readonly<Props>) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t('license.dialog.title')}</DialogTitle>
          <DialogContent>
            <LicenseInfo />
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">{t('misc.close')}</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
